import { cn } from "./cn.js";
import { twMerge } from "../external/tailwind-merge/dist/bundle-mjs.js";
const mergeClasses = (themeConfig, customConfig, rootClassName, variantConfig) => {
  const classes = { ...themeConfig ?? {}, ...customConfig ?? {} };
  Object.keys(customConfig ?? {}).forEach((key) => {
    if (key[key.length - 1] === "&") {
      const baseKey = key.slice(0, key.length - 1);
      classes[baseKey] = twMerge(classes[baseKey], classes[key]);
    }
  });
  if (!!variantConfig) {
    Object.keys(classes).forEach((key) => {
      const variant = variantConfig == null ? void 0 : variantConfig.variant;
      if (!!variant && key !== `${key}_${variant}`) {
        const variantClassname = classes[`${key}_${variant}`];
        classes[key] = twMerge(classes[key], variantClassname);
      }
      const modifier = variantConfig == null ? void 0 : variantConfig.modifier;
      if (!!modifier && key !== `${key}:${modifier}`) {
        const modifierClassname = classes[`${key}:${modifier}`];
        classes[key] = twMerge(classes[key], modifierClassname);
      }
      if (!!modifier && !!variant && key !== `${key}_${variant}:${modifier}`) {
        const modifierClassname = classes[`${key}_${variant}:${modifier}`];
        classes[key] = twMerge(classes[key], modifierClassname);
      }
    });
  }
  Object.keys(classes).forEach((key) => {
    if (key.includes("&") || key.includes(":") || key.includes("_")) {
      delete classes[key];
    }
  });
  return {
    ...classes,
    root: cn(rootClassName, classes.root)
  };
};
export {
  mergeClasses
};
